const contactInfo = {
  image: 'cardbackground.jpg',
  title: 'contact',
  subtitle: 'Full Stack',
  description: 'contact-description',
};

const socialMedia = [
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/in/javarcast',
    icon: ['fab', 'linkedin'],
    copied: false,
  },
  {
    name: 'github2',
    url: 'https://github.com/javarcast',
    icon: ['fab', 'github'],
    copied: false,
    nameLight: 'github',
  },
  {
    name: 'discord',
    url: '#',
    icon: ['fab', 'discord'],
    copied: true,
    text: 'Jesus Varela#8685',
  },
  {
    name: 'skype',
    url: 'https://join.skype.com/invite/xAbgtacwFbfk',
    icon: ['fab', 'skype'],
    copied: false,
  },
  {
    name: 'gmail',
    url: 'mailto:javarcast93@gmail.com',
    icon: ['fab', 'google'],
    copied: false,
  },
];

export {
  contactInfo,
  socialMedia,
};
